import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Seo } from "../../components/site/Seo";

export default function AdminLogin() {
  const { user, checked, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (checked && user && user.role === "admin") nav("/admin", { replace: true });
  }, [checked, user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) nav("/admin", { replace: true });
    else setError(res.error || "Login failed");
  };

  return (
    <div className="min-h-screen bg-obsidian grain flex items-center justify-center px-6 relative">
      <Seo title="Admin" />
      <div className="absolute inset-0 ember-glow" />
      <div className="relative w-full max-w-md">
        <div className="text-center mb-10">
          <p className="eyebrow mb-4">Obsidian Ink</p>
          <h1 className="display text-5xl text-white">Studio Access</h1>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="border border-ash bg-charcoal p-8 space-y-5">
          <label className="block">
            <span className="eyebrow block mb-3">Email</span>
            <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="w-full bg-obsidian border border-ash text-white px-4 py-3.5 outline-none focus:border-ember transition-colors" />
          </label>
          <label className="block">
            <span className="eyebrow block mb-3">Password</span>
            <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
              className="w-full bg-obsidian border border-ash text-white px-4 py-3.5 outline-none focus:border-ember transition-colors" />
          </label>
          {error && <p data-testid="admin-login-error" className="text-red-400 text-sm font-mono">{error}</p>}
          <button data-testid="admin-login-submit" disabled={loading}
            className="w-full bg-ember text-obsidian font-mono text-xs uppercase tracking-[0.2em] font-semibold py-4 hover:bg-white transition-colors disabled:opacity-50">
            {loading ? "Signing in…" : "Enter Studio"}
          </button>
        </form>
      </div>
    </div>
  );
}
